<template>
	<div class="my-5 max-width-layout">
		<v-col class="text-center">
			<v-btn
				color="secondary"
				fab
				top
				right
				small
				:loading="summaryLoading"
				@click="getSummary()"
				class="float-right"
			>
				<v-icon>mdi-refresh</v-icon>
			</v-btn>

			<div class="d-flex justify-center ml-9">
				<h2>{{ $t("Summary Report") }}</h2>
			</div>

			<div class="text-center last-updated-text mt-2 mb-5">
				<span>
					{{ $t(["Last Updated"]) }} {{ lastUpdatedTime }} ({{
						currentDate ? currentDate : ""
					}})
				</span>
			</div>

			<v-alert
				v-model="errorMsgAlert"
				close-text="Close Alert"
				class="alert-text mb-5"
				color="error"
				dark
				dismissible
				ref="snackbarError"
			>
				{{ $t(errorMsg) }}
			</v-alert>

			<div>
				<v-row>
					<v-col v-for="stat in cardStats" :key="stat.label" cols="12" md="6">
						<v-card>
							<v-card-text class="text-center black--text">
								<div v-if="!summaryLoading">
									<h1
										v-if="stat.label == 'Registration'"
										class="font-weight-medium my-2"
									>
										{{ stat.count }}
									</h1>

									<h1 v-else class="font-weight-medium my-2">
										${{ parseInt(stat.value).toFixed(2) }} ({{ stat.count }})
									</h1>
								</div>

								<div v-else>
									<v-progress-circular
										indeterminate
										color="primary"
									></v-progress-circular>
								</div>

								<div>{{ $t(stat.label) }}</div>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<v-btn class="btn-text mt-10" x-large block @click="backToHome()">
				{{ $t(["Back"]) }}
			</v-btn>
		</v-col>
	</div>
</template>

<script>
import { Auth } from "aws-amplify";
import { useAuthenicationStore } from "../../store/authenication";

import moment from "moment";

export default {
	name: "SummaryReport",
	data: () => ({
		summaryLoading: false,
		errorMsgAlert: false,
		errorMsg: "",
		currentDate: null,
		updatedTime: "",
		lastUpdatedTime: "",
		interval: null,
		cardStats: [
			{ label: "Donations" },
			{ label: "Merchandise" },
			{ label: "Registration" },
			{ label: "Refunds" },
		],
	}),
	setup() {
		const authStore = useAuthenicationStore();

		return {
			authStore,
		};
	},
	async created() {
		await this.getSummary();
	},
	destroyed() {
		clearInterval(this.interval);
	},
	methods: {
		backToHome() {
			clearInterval(this.interval);

			this.$router.push({ name: "Home" });
		},
		async getSummary() {
			this.summaryLoading = true;

			try {
				await Auth.currentSession().then(async (data) => {
					await this.authStore
						.getSummaryApi(
							{
								runSiteId: data.accessToken.payload.username,
								eventName: this.authStore.runSiteInfo.eventName,
							},
							data.idToken.jwtToken
						)
						.then((response) => {
							Object.keys(response).forEach((key) => {
								if (key == "donations") {
									this.cardStats[0] = {
										...this.cardStats[0],
										value: response[key].amount,
										count: response[key].count,
									};
								} else if (key == "merchandise") {
									this.cardStats[1] = {
										...this.cardStats[1],
										value: response[key].amount,
										count: response[key].count,
									};
								} else if (key == "registrations") {
									this.cardStats[2] = {
										...this.cardStats[2],
										count: response[key].count,
									};
								} else if (key == "refunds") {
									this.cardStats[3] = {
										...this.cardStats[3],
										value: response[key].amount,
										count: response[key].count,
									};
								}
							});

							this.updatedTime = new Date();

							this.interval = setInterval(() => {
								let momentObject = moment(this.updatedTime).locale(
									this.$i18n.locale
								);
								this.lastUpdatedTime = momentObject.fromNow();
							}, 1000);

							this.currentDate = moment(new Date()).format("MMMM D, YYYY");

							this.summaryLoading = false;
						});
				});
			} catch (error) {
				this.errorMsgAlert = true;
				this.errorMsg = error.message == undefined ? error : error.message;

				this.$nextTick(() => {
					const el = this.$el.querySelector("snackbarError");
					this.$vuetify.goTo(-5, el);

					return;
				});
			}
		},
	},
};
</script>

<style scoped>
@media screen and (min-width: 480px) {
	.max-width-layout {
		max-width: 500px;
		margin: 0 auto;
	}
}

@media screen and (min-width: 960px) {
	.max-width-layout {
		max-width: 850px;
		margin: 0 auto;
	}
}
.last-updated-text {
	font-size: 14px;
	font-weight: bold;
}
</style>
